module.exports = __webpack_public_path__ + "img/spinner.b9d95dff.jpg";